import { render, staticRenderFns } from "./clear_section_index.vue?vue&type=template&id=28604f42&scoped=true"
import script from "./clear_section_index.vue?vue&type=script&lang=js"
export * from "./clear_section_index.vue?vue&type=script&lang=js"
import style0 from "./clear_section_index.vue?vue&type=style&index=0&id=28604f42&prod&scoped=true&lang=less"
import style1 from "./clear_section_index.vue?vue&type=style&index=1&id=28604f42&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28604f42",
  null
  
)

export default component.exports